import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-720eadc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ", -1))
const _hoisted_3 = { style: {"display":"grid","grid-template-columns":"auto"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"1.3rem"} }, " You are successfully logged out of the application ", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Log back in")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_ion_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_6
      ])
    ]),
    _: 1
  }))
}